import { gql } from '@apollo/client'

// returns array of subs
export const GET_USER_SUBSCRIPTIONS = gql`
    query get_user_subscriptions {
        get_user_subscriptions {
            id
            lot_id
            start_date
            end_date
            subscription_status
            subscription_bookings {
                start_date
                price
                plates {
                    plate
                }
                payment_method
                lot_name
                lot_id
                lot_address
                end_date
                email
                created_at_iso_str
                invoices {
                    invoice_id
                }
                booking_ref
                booking_type
                night_parking_data {
                    iso_duration
                    rrule
                }
            }
            user_email
            plates
            subscription_price
            lot_name
            lot_address
        }
    }
`

// enum SubscriptionStatus {
//   ACTIVE
//   CANCELLED
// }
